document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.mas-backstock-cstm-preorder-btn');
  if (!btn) return;
  const form = btn.closest('form');
  if (!form) return;

  // Kill the MAS Backstock handler before it redirects to /cart
  e.preventDefault();
  e.stopImmediatePropagation();

  btn.classList.add("new-c-loader");

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok){
      throw new Error('cart/add failed: ' + res.status);
      btn.classList.remove("new-c-loader");
    }
    else{
      btn.classList.remove("new-c-loader");
    }

    // Refresh Rebuy's cart state, then open the Smart Cart drawer
    document.dispatchEvent(new CustomEvent('rebuy:cart.refresh'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.show) {
      window.Rebuy.SmartCart.show();
    }
  } catch (err) {
    console.error('[preorder-cart-fix]', err);
    btn.classList.remove("new-c-loader");
  }
}, true); // capture phase — runs before the app's bubble-phase listener